import React from 'react'

export default function CloseSearch(props) {
  return (
    <svg
      {...props}
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8.9541" y="7.30432" width="11.6645" height="2.33291" transform="rotate(45 8.9541 7.30432)" fill="#CACACA"/>
      <rect x="7.30469" y="15.5524" width="11.6645" height="2.33291" transform="rotate(-45 7.30469 15.5524)" fill="#CACACA"/>
      <circle cx="12" cy="12" r="11" stroke="#CACACA" strokeWidth="2"/>
    </svg>
  )
}
